import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-finish-password',
  templateUrl: './finish-password.component.html',
  styleUrls: ['./finish-password.component.css']
})
export class FinishPasswordComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
